import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  rows: {
    id: number;
    nome: string;
    email: string;
    telefone: string;
    celular: string;
    status: string;
    ultimo_login: string;
    created_at: string;
  }[];
  length: number;
}

// tipagem do que o hook retorna
type IUsuariosReponse = IResponseData;

async function getUsuarios(
  search: string,
  status: string,
  page?: number,
  pageSize?: number,
): Promise<IUsuariosReponse> {
  const response = await backend.get<IResponseData>('/usuarios', {
    params: {
      search,
      status: Number(status),
      page: page ? page + 1 : null,
      pageSize,
    },
  });
  return response.data;
}

export function useUsuarios(
  search: string,
  status: string,
  page?: number,
  pageSize?: number,
) {
  return useQuery(
    ['usuarios', search, status, page, pageSize],
    () => getUsuarios(search, status, page, pageSize),
    {
      keepPreviousData: true,
      staleTime: 1000 * 30,
      cacheTime: 1000 * 60 * 2,
      refetchOnWindowFocus: true,
      refetchOnMount: false,
      retry: 1,
    },
  );
}
